import * as THREE from 'three';

export const disposeO3D = (object3D) => {
  if (!object3D) return;
  if (object3D.children && object3D.children.length > 0) {
    object3D.children.forEach((e) => {
      disposeO3D(e);
    });
  }
  if (object3D.parent) object3D.parent.remove(object3D); //.removeFromParent()
  if (object3D.geometry && object3D.geometry.dispose) {
    object3D.geometry.dispose();
  }
  if (object3D.dispose) {
    object3D.dispose();
  }
  if (object3D.clear) {
    object3D.clear();
  }
};

export const disposeO3D_child = (object3D) => {
  if (!object3D) return;
  if (object3D.children && object3D.children.length > 0) {
    object3D.children.forEach((e) => {
      disposeO3D(e);
    });
  }
};
